export default __webpack_public_path__ + "static/media/playtable_half.87503795.png";